module.exports = __webpack_public_path__ + "static/media/ic-share-active.be15fdca.svg";